import * as React from 'react'
import { clsx, type ClassValue } from 'clsx'

const cn = (...inputs: ClassValue[]) => clsx(inputs)

const Progress = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    value?: number
  }
>(({ className, value = 0, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('relative w-full h-3 rounded-full overflow-hidden', className)}
    style={{
      backgroundColor: '#E5E7EB', // Light gray track (similar to v0 bg-secondary)
      boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.1)', // subtle inner depth
    }}
    {...props}
  >
    <div
      className="h-full transition-all duration-300 ease-in-out rounded-full"
      style={{
        width: `${value}%`,
        background: 'linear-gradient(90deg, #3B82F6 0%, #2563EB 100%)', // v0 primary gradient blue
      }}
    />
  </div>
))
Progress.displayName = 'Progress'

export { Progress }
